import { CoreDataSecurityMonitorsByApplicationName } from './name';
import { createRemoveSyncSlice } from '@sonar-software/xuder';
import { DeleteDataSecurityMonitorByIdRequest } from '@api/data-security';
import { getCoreDataSecurityMonitorsByApplicationSlice } from './get';

export const removeCoreDataSecurityMonitorsByApplicationSyncSlice = createRemoveSyncSlice({
	name: CoreDataSecurityMonitorsByApplicationName,
	state: getCoreDataSecurityMonitorsByApplicationSlice.asyncState,
	transform: (action: DeleteDataSecurityMonitorByIdRequest, state = []) =>
		state?.filter((monitor) => action.monitorId !== monitor.id) ?? []
});
